import script from "./ReservationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationModal.vue?vue&type=style&index=0&id=072da798&lang=scss"

const __exports__ = script;

export default __exports__